module.exports = __webpack_public_path__ + "static/media/skuld.fbfd8bd1.mp3";